module.exports = __webpack_public_path__ + "static/media/Movie1.c4e3a391.jpg";